import {BsFillTrash2Fill, BsEraserFill} from "react-icons/bs";
import {useEffect, useState} from "react";
import {useForm} from "../../../hooks/useForm";
import {requester} from "../../../services/requester";
import baseUrl from "../../../baseUrl";
import {useConfirm} from "../../../contexts/ConfirmContext";



export const DataUploadRow = ({data, index, handleEditData}) => {
    const request = requester();
    const confirm = useConfirm();
    const [showEdit, setShowEdit] = useState(false);

    const {values, changeHandler, onSubmitEditValues} = useForm({
        company_name: data["company_name"],
        declared_land: data["declared_land"],
        unsuitable_land: data["unsuitable_land"],
        suitable_land: data["suitable_land"]
    });

    useEffect(() => {
        onSubmitEditValues({
            company_name: data["company_name"],
            declared_land: data["declared_land"],
            unsuitable_land: data["unsuitable_land"],
            suitable_land: data["suitable_land"]
        })
    }, [data])

    const toggleShowEdit = () => {
        setShowEdit(!showEdit);
    };

    // Ш1: изход без запис — полетата се връщат към записаното.
    const затвори = () => {
        onSubmitEditValues({
            company_name: data["company_name"],
            declared_land: data["declared_land"],
            unsuitable_land: data["unsuitable_land"],
            suitable_land: data["suitable_land"]
        });
        setShowEdit(false);
    };

    const onClickEditHandle = async (e) => {
        e.preventDefault();

        const body = {
            company_name: values.company_name,
            declared_land: Number(values.declared_land),
            unsuitable_land: Number(values.unsuitable_land),
            suitable_land: Number(values.suitable_land)
        };

        try {
            await request.put(`${baseUrl()}/companies-initial-info/${data.id}`, body);
            handleEditData();
            toggleShowEdit();
        } catch (error) {
            alert(error.message || 'Възникна грешка при заявката.');
        }
    };

    const onClickDeleteHandle = async () => {
        // Р7: същото потвърждение като навсякъде (contexts/ConfirmContext).
        if (!await confirm({
            title: "Да се изтрие ли този ред?",
            message: "Премахва се правното основание на ползвателя за тази "
                + "година и землище.",
            detail: `${data.company_name || ""} · ${data.settlement_ekatte || ""}`,
        })) return;

        request.delete(`${baseUrl()}/companies-initial-info/${data.id}`)
            .then(() => {
                handleEditData();
            })
            .catch(err => alert(err.message || 'Грешка при изтриване.'));
    };

    return (
        <>
            <tr>
                <td className="text-center" style={{paddingTop: "14px"}}>{index + 1}</td>
                <td className="text-center" style={{paddingTop: "14px"}}>{data["bullstat"]}</td>
                <td className="text-start" style={{paddingTop: "14px"}}>{data["company_name"]}</td>
                <td className="text-center" style={{paddingTop: "14px"}}>{data["settlement_ekatte"]}</td>
                <td className="text-center" style={{paddingTop: "14px"}}>{data["declared_land"]}</td>
                <td className="text-center" style={{paddingTop: "14px"}}>{data["unsuitable_land"]}</td>
                <td className="text-center" style={{paddingTop: "14px"}}>{data["suitable_land"]}</td>
                <td className="text-center" style={{paddingTop: "14px"}}>{data["year"]}</td>
                <td>
                    <button onClick={toggleShowEdit} data-bs-toggle="tooltip" title="Редакция" type="submit"
                            className="btn btn-warning"><BsEraserFill/></button>
                </td>
                <td>
                    <button onClick={onClickDeleteHandle} data-bs-toggle="tooltip" title="Изтриване" type="button"
                            className="btn btn-danger"><BsFillTrash2Fill/>
                    </button>
                </td>
            </tr>
            {showEdit && (
                <tr style={{background: "var(--app-neutral-bg)"}}>
                    <td className="text-center" style={{paddingTop: "12px", fontStyle: "italic"}}>{index + 1}</td>
                    <td className="text-center"
                        style={{paddingTop: "12px", fontStyle: "italic"}}>{data["bullstat"]}</td>
                    {/*<td className="text-center" style={{paddingTop: "12px", fontStyle: "italic"}}>{data["company_name"]}</td>*/}
                    <td className="text-center" style={{paddingTop: "12px"}}><input onChange={changeHandler} size={10}
                                                                                    type="text"
                                                                                    value={values.company_name}
                                                                                    name="company_name"/></td>
                    <td className="text-center"
                        style={{paddingTop: "12px", fontStyle: "italic"}}>{data["settlement_ekatte"]}</td>
                    {/*<td className="text-center" style={{paddingTop: "12px"}}>{data["declared_land"]}</td>*/}
                    <td className="text-center" style={{paddingTop: "12px"}}><input onChange={changeHandler} size={5}
                                                                                    type="text"
                                                                                    value={values.declared_land}
                                                                                    name="declared_land"/></td>
                    {/*<td className="text-center" style={{paddingTop: "12px"}}>{data["unsuitable_land"]}</td>*/}
                    <td className="text-center" style={{paddingTop: "12px"}}><input onChange={changeHandler} size={5}
                                                                                    type="text"
                                                                                    value={values.unsuitable_land}
                                                                                    name="unsuitable_land"/></td>
                    {/*<td className="text-center" style={{paddingTop: "12px"}}>{data["suitable_land"]}</td>*/}
                    <td className="text-center" style={{paddingTop: "12px"}}><input onChange={changeHandler} size={5}
                                                                                    type="text"
                                                                                    value={values.suitable_land}
                                                                                    name="suitable_land"/></td>
                    <td className="text-center" style={{paddingTop: "12px", fontStyle: "italic"}}>{data["year"]}</td>
                    <td colSpan={2}>
                        {/* Ш1: бутонът в отворената форма казва какво прави —
                            „Запази", не „Редакция"; до него изход без запис. */}
                        <div className="d-flex gap-2">
                            <button onClick={onClickEditHandle} style={{flex: 1}} type="button"
                                    className="btn btn-warning">Запази
                            </button>
                            <button onClick={затвори} type="button"
                                    className="btn btn-outline-secondary">Затвори
                            </button>
                        </div>
                    </td>
                </tr>
            )}        </>
    )
}